import React from 'react';
import { Typography } from '@loomstateorg/shared-frontend';
import getFontSize from '@loomstateorg/shared-frontend/utils/getFontSize';

export interface Title {
  title: string;
  subtitle: string;
  titleFontSize?: string;
  subtitleFontSize?: string;
}

export interface Props {
  title: Title;
  titleClassName?: (titleFontSize: string) => string;
  children?: React.ReactNode;
}

const Title: React.FC<Props> = ({
  title,
  titleClassName = (size) => `text-center text-24 md:text-${getFontSize(18, size)}`,
}) => (
  <div className="mt-52 flex flex-col items-center md:mb-30 lg:mb-60">
    <Typography className={titleClassName(title.titleFontSize || '1x')} data-testid="eco-title">
      {title.title}
    </Typography>
    <Typography className={`text-${getFontSize(14, title.subtitleFontSize || '1x')}`}>{title.subtitle}</Typography>
  </div>
);

export default Title;
